export default {
  name: "ScoreTable1Header",
  props: {
    item: {
      type: String,
      default: ''
    }
  }
};